<template>
  <form class="space-y-4 text-left tracking-wider">
    <div>
      <label class="block text-base font-bold mb-1 uppercase">
        E-mail *
      </label>
      <input
        name="email"
        type="email"
        required
        class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700"
        v-model="dataShared.state.cLogin.signIn.email"
      />
    </div>
    <div>
      <label class="block text-base font-bold mb-1 uppercase"
        >Senha *</label
      >
      <input
        type="password"
        class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700"
        v-model="dataShared.state.cLogin.signIn.password"
      />
    </div>

    <button
      type="submit"
      class="w-full py-3 bg-red-700 text-white font-bold uppercase hover:bg-red-800 transition"
      @click.prevent="login()"
    >
      Entrar
    </button>
  </form>
</template>

<script setup>
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import { showToast as toast } from '@/helpers/UseToasts'
import SignUp from './SignUp.vue'
import { markRaw } from 'vue'
import Events from '../../authenticated/events.vue'

async function login () {
  dataShared.dispatch('activeLoading')

  const raw = dataShared.getters.getRedirectFighterCoupon
  const redirect = (typeof raw === 'string' && raw.startsWith('/')) ? raw : '/events'
  dataShared.dispatch("setRedirectFighterCoupon", null)

  await SharedService.login(dataShared.state.cLogin.signIn, redirect)
    .then(res => {
      dataShared.dispatch('desactiveLoading')
      if (res.data.user) {
        dataShared.commit('SET_USER', res.data.user)
      }
      dataShared.dispatch('setComponentActive', markRaw(Events))
      toast('Bem-vindo', res.data.message, 'success')

      // window.location.href = `${process.env.VUE_APP_BASE_URL}events`
      window.location.href = res.data?.redirect
    })
    .catch(err => {
      dataShared.dispatch('desactiveLoading')

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        dataShared.dispatch('setComponentActiveLogin', markRaw(SignUp))

        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 401) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado com sua solicitação',
        'error'
      )
    })
}

</script>
